import { z } from 'zod';

/**
 * POST /api/products/{product_id}/users リクエスト・レスポンスの型定義
 * ユーザー追加機能の API 仕様 (user_registration.md 4.1 参照)
 */

/** 追加可能な Product Role の ID */
export const PRODUCT_ROLE_OPTIONS = [
  { value: '2', label: '承認者' },
  { value: '3', label: '管理者' },
  { value: '4', label: '開発者' },
] as const;

/** POST /api/products/{product_id}/users リクエストボディの Zod スキーマ */
export const AddProductUserRequestSchema = z.object({
  email: z.string().min(1).email('メールアドレスの形式が不正です'),
  role_id: z.union([z.literal(2), z.literal(3), z.literal(4)]),
  github_account: z.string().min(1, 'GitHub アカウント名は必須です'),
});

/** POST /api/products/{product_id}/users リクエストボディの型 */
export type AddProductUserRequest = z.infer<typeof AddProductUserRequestSchema>;

/**
 * ユーザー追加エラーレスポンスの Zod スキーマ
 * `detail` が error_code / request_id / message を持つオブジェクト形式に対応する。
 */
export const AddProductUserErrorResponseSchema = z.object({
  detail: z.object({
    error_code: z.string(),
    request_id: z.string(),
    message: z.string(),
  }),
});

/** ユーザー追加エラーレスポンスの型 */
export type AddProductUserErrorResponse = z.infer<
  typeof AddProductUserErrorResponseSchema
>;
